import { ModelBase } from 'store/model-base';

export class HeroBannerInfo extends ModelBase {
    public static storeName: string = 'heroBanner';

    public id: string;
    public nickname: string;
    public header: Header;
    public subheader: Header;
    public currentCycle: CurrentCycle;
    public ctaButton: CtaButton;

    public static create<T extends ModelBase>(response: ApiResponse): T {
        if (response.header) {
            response.header.nickname = response.header.nickname || '';
        } else {
            response.header = {
                nickname: ''
            };
        }

        if (response.subheader) {
            response.subheader.dataUsed = response.subheader.dataUsed || '';
            response.subheader.dataCost = response.subheader.dataCost || '';
            response.subheader.nickname = response.subheader.nickname || '';
            response.subheader.paymentDate = response.subheader.paymentDate || '';
            response.subheader.amount = response.subheader.amount || '';
            response.subheader.throttleLimit = response.subheader.throttleLimit || '';
            response.subheader.nextCycleStartMonth = response.subheader.nextCycleStartMonth || '';
            response.subheader.nextCycleStartDate = response.subheader.nextCycleStartDate || '';
        } else {
            response.subheader = {
                dataCost: '',
                dataUsed: '',
                throttleLimit: '',
                nickname: '',
                paymentDate: '',
                amount: '',
                unlimitedPlanName: '',
                nextCycleStartDate: '',
                nextCycleStartMonth: ''
            };
        }

        if (!response.currentCycle) {
            response.currentCycle = {
                startDate: '',
                endDate: '',
                startMonth: '',
                endMonth: '',
                endYear: ''
            };
        }

        if (!response.ctaButton) {
            response.ctaButton = {};
        }

        response.ctaButton.oddDeliveryStartTime = response.ctaButton.oddDeliveryStartTime || '';
        response.ctaButton.oddDeliveryEndTime = response.ctaButton.oddDeliveryEndTime || '';
        response.ctaButton.oddTrackingUrl = response.ctaButton.oddTrackingUrl || '';
        response.ctaButton.fulfillmentMethod = response.ctaButton.fulfillmentMethod || '';

        return super.create<T>(response);
    }
}
